import React, { useEffect, useState } from 'react';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import HeaderSection from './Components/HeaderSections';
import axios from 'axios';
import { getApiHeader } from 'utlis/commonfunctions';
import { ThreeDots } from 'react-loader-spinner'

const SERVER_URL = process.env.REACT_APP_API_URL;

function VideoTutorials() {
  const [selectedCategoryId, setSelectedCategoryId] = useState(""); // State for selected category
  const [categoryData, setCategoryData] = useState([]);
  const [videoData, setVideoData] = useState([]);
  const [loading, setLoading] = useState(false); // Loading state


  const styles = {
    wrapper: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backdropFilter: "blur(1px)",
      zIndex: 9999,
    },
  };









  // Fetch categories on initial render
  useEffect(() => {
    handleFetchCategories();
    handleFetchVideos(); // Fetch all videos initially
  }, []);

  // Fetch videos when category changes
  useEffect(() => {
    handleFetchVideos(selectedCategoryId); // Fetch videos for the selected category
  }, [selectedCategoryId]);

  const handleFetchCategories = async () => {
    try {
      const headers = await getApiHeader();
      const categoryResponse = await axios.post(`${SERVER_URL}get-tutorial-video-categories`, {}, { headers });

      if (categoryResponse?.data?.status === 200) {
        const categories = categoryResponse.data.data.tutoral_video_categories.map(item => ({
          id: item.tutorial_video_category_id,
          name: item.category_name,
        }));
        setCategoryData(categories);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const handleFetchVideos = async (categoryId = "") => {
    try {
      setLoading(true); // Show loader
      const headers = await getApiHeader();
      const payload = categoryId ? { tutorial_video_category_id: categoryId } : {};
      const videoResponse = await axios.post(`${SERVER_URL}get-tutorial-video-list`, payload, { headers });

      if (videoResponse?.data?.status === 200) {
        const videos = videoResponse.data.data.tutoral_videos.flatMap(item => item.videos);
        setVideoData(videos);
      }
    } catch (error) {
      console.error("Error fetching videos:", error);
    } finally {
      setLoading(false); // Hide loader
    }
  };

  const handleCategoryChange = (categoryId) => {
    setSelectedCategoryId(categoryId); // Update selected category ID
  };

  return (
    <div>
      <DashboardLayout>
        <DashboardNavbar />
        <HeaderSection />


        {loading && (
        <div style={styles.wrapper}>
          <ThreeDots
            visible={loading}
            height="80"
            width="80"
            color="#e20e75"
            radius="9"
            ariaLabel="three-dots-loading"
          />
        </div>
      )}

        <div className="payment-gateway-wrapper" style={{ margin: "10px" }}>
          <div>
            <label>Please select a topic to watch a video:</label>
          </div>

          <div className="row" style={{ margin: "10px 0" }}>
            <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-3">
              <div style={{ display: "flex", alignItems: "center" }}>
                <input
                  type="radio"
                  name="category"
                  id="category-all"
                  onChange={() => handleCategoryChange("")} // Empty string for "All"
                  style={{ width: "16px", height: "17px" }}
                  checked={selectedCategoryId === ""}
                />
                <label
                  htmlFor="category-all"
                  style={{ marginLeft: "10px", cursor: "pointer" }}
                >
                  All
                </label>
              </div>
            </div>
            {categoryData.map((category, index) => (
              <div key={index} className="col-12 col-sm-6 col-md-4 col-lg-3 mb-3">
                <div style={{ display: "flex", alignItems: "center" }}>
                  <input
                    type="radio"
                    name="category"
                    id={`category-${index}`}
                    onChange={() => handleCategoryChange(category.id)} // Pass category ID
                    style={{ width: "16px", height: "17px" }}
                    checked={selectedCategoryId === category.id}
                  />
                  <label
                    htmlFor={`category-${index}`}
                    style={{ marginLeft: "10px", cursor: "pointer" }}
                  >
                    {category.name}
                  </label>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="row" style={{ margin: "20px 0" }}>
          {loading ? (
            <p style={{ textAlign: "center", width: "100%" }}>Loading videos...</p>
          ) : videoData.length > 0 ? (
            videoData.map((video, index) => (
              <div key={index} className="col-12 col-sm-6 col-md-6 col-lg-4 mb-4 ">
                <div
                  className='videoCards'
                  style={{
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                    textAlign: "center",
                   
                  }}
                >
                  <video
                 className='video-card-content'
                    controls
                    controlsList="nodownload"
                    disablePictureInPicture
                    style={{
                      width: "100%",
                      // height: "180px",
                      objectFit: "cover",
                      borderTopLeftRadius: "8px",
                      borderTopRightRadius: "8px",
                    }}
                    poster={video.thumbnail}
                  >
                    <source src={video.url} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                  <div style={{ padding: "10px" }}>
                    <h4 style={{ fontSize: "16px", fontWeight: "bold", margin: "10px 0" }}>
                      {video.title}
                    </h4>
                    <p style={{
                      fontSize: "14px",
                      color: "#666",
                      wordWrap: "break-word",
                      whiteSpace: "normal"
                    }}>
                      {video.description}
                    </p>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p style={{ textAlign: "center", width: "100%" }}>No videos available.</p>
          )}
        </div>
      </DashboardLayout>
    </div>
  );
}

export default VideoTutorials;
